// "Also works with these locations" on the contact form (Stephanie
// 2026-10-27/28, Bozzuto: one person orders for several buildings). The
// contact stays on their home location; each location picked here also lists
// them and can send them quotes. Search, because Bozzuto has ~430 locations.
import { useState } from "react";
import { X } from "lucide-react";
import { Input } from "@/components/ui/Input";
import { linkChoices, type LinkableAccount } from "@merchd/shared";

export function AlsoWorksWith({
  company,
  homeId,
  picked,
  onChange,
  labelClassName,
}: {
  company: { main: LinkableAccount; locations: readonly LinkableAccount[] };
  homeId: string;
  /** The picked accounts (id + name), in the order they were added. */
  picked: LinkableAccount[];
  onChange: (next: LinkableAccount[]) => void;
  labelClassName: string;
}) {
  const [query, setQuery] = useState("");
  const offered = linkChoices(company, homeId, picked.map((p) => p.id), query);
  return (
    <div>
      <span className={labelClassName}>Also works with these locations</span>
      {picked.length > 0 ? (
        <ul className="mb-2 flex flex-wrap gap-2">
          {picked.map((p) => (
            <li
              key={p.id}
              className="inline-flex items-center gap-1.5 rounded-full border border-peach-300 bg-white px-2.5 py-1 text-xs font-medium text-brown-500"
            >
              {p.name}
              <button
                type="button"
                onClick={() => onChange(picked.filter((x) => x.id !== p.id))}
                className="text-brown-300 hover:text-rust-500"
                aria-label={`Remove ${p.name}`}
              >
                <X className="h-3.5 w-3.5" />
              </button>
            </li>
          ))}
        </ul>
      ) : null}
      <Input
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        placeholder={`Type a ${company.main.name} location to add`}
        aria-label="Search locations to add"
      />
      {offered.length > 0 ? (
        <ul className="mt-1 overflow-hidden rounded-md border border-rule bg-white">
          {offered.map((a) => (
            <li key={a.id}>
              <button
                type="button"
                onClick={() => {
                  onChange([...picked, a]);
                  setQuery("");
                }}
                className="block w-full px-3 py-2 text-left text-sm text-ink hover:bg-peach-50"
              >
                + {a.name}
              </button>
            </li>
          ))}
        </ul>
      ) : query.trim() ? (
        <p className="mt-1 text-xs text-muted">No other location matches “{query.trim()}”.</p>
      ) : null}
      <span className="mt-1 block text-xs text-muted">
        They stay on their own location. Each one added here also lists them and can send them quotes.
      </span>
    </div>
  );
}
